import React from 'react'
import classNames from 'classnames'

import { BUMP_UP, getColorTheme, iconWidth, mq } from '../../../utils'
import Image from 'next/image'
import { Text } from '../../Text'
import { ICard } from '../index'
import CTALinkPlaceholder from '../../CTALink/CTALinkPlaceholder'

export const CardRounded: React.FC<ICard> = ({
  title,
  body,
  cta,
  icon,
  isHiddenOnMobile,
  alignment = 'stretch',
  cardColor,
}) => {
  const themeColors = getColorTheme('legacy', cardColor)

  const classes = classNames('card card--rounded', {
    [`card--align-${alignment}`]: alignment,
  })

  return (
    <div className={classes} data-testid="card">
      {icon && (
        <div className="card-icon">
          <Image
            loader={(image) => image.src}
            alt={icon.altText}
            src={icon.url}
            height={icon.height || 0}
            width={icon.width || 0}
          />
        </div>
      )}
      <h3 className="card-title">
        <Text size="lg+">{title}</Text>
      </h3>

      {body && (
        <p className="card-body">
          <Text size="body">{body.trim()}</Text>
        </p>
      )}

      {cta ? (
        <div className="cta">
          <CTALinkPlaceholder {...cta} bgColor={cta.bgColor ?? themeColors.CTATheme} />
        </div>
      ) : null}

      <style jsx>{`
        .card {
          padding: 1.5rem 2.25rem;
          color: ${themeColors.textColor};
          background-color: ${themeColors.backgroundColor};
          cursor: ${cta ? 'pointer' : 'default'};
          min-height: ${cta ? '100%' : 'none'};
          height: 100%;
        }

        .card-icon {
          justify-self: ${alignment};
          width: ${iconWidth}px;
        }

        .card-body {
          margin-bottom: ${cta ? '2.625rem' : '0'};
        }

        .card--align-center {
          align-items: center;
          text-align: center;
        }

        @media (${mq.tablet}) {
          .card {
            transition: ${BUMP_UP.TRANSITION};
          }

          .card:hover {
            transform: ${BUMP_UP.TRANSFORM};
          }
        }

        @media (${mq.mobile}) {
          .card {
            display: ${isHiddenOnMobile ? 'none' : 'flex'};
          }
        }
      `}</style>

      <style jsx>
        {`
          .card {
            display: flex;
            flex-direction: column;
            border-radius: 8px;
            transform: translate3d(0, 0, 0);
          }

          .card-icon {
            margin-bottom: 16px;
          }

          .card-title {
            margin: 0 0 16px;
          }

          .card-body {
            line-height: 1.4;
          }

          @media (${mq.tablet}) {
            .card {
              border-radius: 25px;
              margin-top: 10px; /*  provide space for bump-up */
            }

            .cta {
              margin-top: auto;
            }
          }
        `}
      </style>
    </div>
  )
}
